import $ from 'jquery';

export const dynamicHeight = () => {
    var checkMenu = $('.tile-container.tile-sm').length;
    if (checkMenu > 1){
        var maxHeight = Math.max.apply(null, $(".tile-container .thumb-heading").map(function (){
                return $(this).height();
            }).get());
            $('.tile-container.tile-sm').each(function(){
                if (maxHeight < 100){
                    $(this).css({
                        'min-height' : maxHeight+20
                    });
                } /*else {
                    $(this).css({
                        'min-height' : maxHeight+20,
                        'margin-bottom' : (maxHeight/2)+'px'
                    });
                }*/
            });
            $('.tile-container .thumb-heading').each(function(){
                $(this).height(maxHeight);
            });
    }
}

